import { Numeric6BoxIcon } from './Numeric6BoxIcon';

/**
 * author: Google
 * id DC1FE999-3DD7-423B-95A5-89005C66875E
 * name numeric-6-box
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/numeric-6-box.svg
 * tags
 * - Alpha / Numeric 
 */
export const NumericSixBoxIcon = Numeric6BoxIcon;
export default NumericSixBoxIcon